import { AlertDialog as AlertDialogPrimitive } from '@base-ui/react/alert-dialog';

export function AlertDialogPortal({ ...props }: AlertDialogPrimitive.Portal.Props) {
  return <AlertDialogPrimitive.Portal data-slot="alert-dialog-portal" {...props} />;
}
